module.exports = __webpack_public_path__ + "45fb93e18cae5c2d54b7ba7dc0bdf89f.pdf";